import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper/modules';
import { Nav } from '../components/Nav.tsx';
import { Footer } from '../components/Footer.tsx';
const HERO_IMAGE = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/hero-asset-1kdlz0j87rk.png';
const GENERATIVE_IMAGE = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/generative-uidwanur4cj.png';
const INTERACTIVE_IMAGE = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/interactive-yszjw1un1u.png';
const ICON_1 = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/icon-1-9gdinkfy65p.png';
const ICON_2 = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/icon-2-uo63d4adlo.png';
const ICON_3 = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/icon-3-xik9xxekuvk.png';
const WHO_ICON_1 = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/icon-1-284ywi0mcw.png';
const WHO_ICON_2 = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/icon-2-4kasd7uy7xn.png';
const WHO_ICON_3 = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/icon-3-akys77psz1b.png';
const WHO_ICON_4 = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/icon-4-4df2tpzxl35.png';
export const MCPApps = () => {
  const conceptsSwiperRef = useRef<any>(null);
  return <main>
      <Nav />

      {/* ── Section 1: Hero ── */}
      <section data-name="MCP Apps Hero" data-nav-theme="light" style={{
      backgroundColor: '#FCFAF6'
    }}>
        <div data-name="Hero Content" className="mcp-hero-inner" style={{
        maxWidth: '1360px',
        margin: '0 auto',
        paddingLeft: '24px',
        paddingRight: '24px',
        paddingTop: '180px',
        paddingBottom: '80px',
        display: 'flex',
        gap: '80px',
        alignItems: 'center'
      }}>
          {/* Left: title + description */}
          <div data-name="Hero Copy" className="mcp-hero-copy animate-fade-slide-up" style={{
          width: '48%',
          flexShrink: 0
        }}>
            <h1 data-name="Hero Title" className="mcp-hero-title" style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400,
            fontSize: '120px',
            lineHeight: 1.0,
            color: '#091717',
            margin: 0
          }}>
              MCP apps
            </h1>
            <p data-name="Hero Description" style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400,
            fontSize: 'clamp(16px, 1.5vw, 20px)',
            lineHeight: 1.4,
            marginTop: '24px',
            marginBottom: 0
          }} className="mcp-hero-desc text-[#091717]">
              The open standard for interactive UI inside AI conversations. Built by MCP-UI, Anthropic, and OpenAI — and ready for production.
            </p>
          </div>

          {/* Right: hero image */}
          <div data-name="Hero Image" className="animate-fade-slide-up-delay-1" style={{
          flex: 1,
          minWidth: 0
        }}>
            <img src={HERO_IMAGE} alt="MCP Apps interface preview" loading="eager" style={{
            width: '100%',
            aspectRatio: '4 / 3',
            objectFit: 'cover',
            display: 'block'
          }} />
          </div>
        </div>
      </section>

      {/* ── Section 2: Definition + Comparison ── */}
      <section data-name="MCP Definition" data-nav-theme="light" style={{
      backgroundColor: '#FCFAF6',
      paddingTop: '120px',
      paddingBottom: '120px'
    }}>
        <div data-name="Definition Content" className="mcp-definition-inner" style={{
        maxWidth: '1360px',
        margin: '0 auto',
        paddingLeft: '24px',
        paddingRight: '24px'
      }}>
          {/* Large mixed-font text */}
          <p data-name="Definition Headline" className="mcp-definition-headline" style={{
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400,
          fontSize: '56px',
          lineHeight: 1.15,
          color: '#091717',
          maxWidth: '1000px',
          margin: 0
        }}>
            The Model Context Protocol (MCP) is an open standard that{' '}
            <em style={{
            fontFamily: 'Instrument Serif, serif',
            fontStyle: 'italic',
            fontWeight: 400,
            letterSpacing: '-0.02em'
          }}>connects</em>
            {' '}AI models to{' '}
            <em style={{
            fontFamily: 'Instrument Serif, serif',
            fontStyle: 'italic',
            fontWeight: 400,
            letterSpacing: '-0.02em'
          }}>outside</em>
            {' '}data and tools.
          </p>

          {/* Sub-description */}
          <p data-name="Definition Description" style={{
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400,
          fontSize: 'clamp(16px, 1.5vw, 20px)',
          lineHeight: 1.4,
          marginTop: '32px',
          marginBottom: 0,
          maxWidth: '900px'
        }} className="mcp-definition-desc text-[#091717]">
            Think of MCP like a USB-C port for AI applications. Just as USB-C provides a standardized way to connect electronic devices, MCP provides a standardized way for AI applications to connect to external systems.
          </p>

          {/* Two-column comparison grid */}
          <div data-name="Comparison Grid" className="mcp-comparison-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gap: '60px',
          marginTop: '48px'
        }}>
            {/* Left: Generative / Static */}
            <div data-name="Generative Column">
              <div data-name="Column Header" className="mcp-col-header" style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'baseline',
              marginBottom: '24px'
            }}>
                <span className="mcp-col-title" style={{
                fontFamily: 'Instrument Sans, sans-serif',
                fontWeight: 500,
                fontSize: '24px',
                color: '#091717'
              }}>
                  Generative
                </span>
                <span className="mcp-col-badge" style={{
                fontFamily: 'Instrument Sans, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                borderRadius: '999px',
                border: '1px solid rgba(9,23,23,0.12)',
                padding: '5px 12px',
                color: 'rgba(9,23,23,0.6)',
                background: 'transparent',
                whiteSpace: 'nowrap'
              }}>
                  Static
                </span>
              </div>

              <img src={GENERATIVE_IMAGE} alt="Generative AI experience — text-based responses" style={{
              width: '100%',
              aspectRatio: '4 / 3',
              objectFit: 'cover',
              display: 'block'
            }} />

              <p style={{
              fontFamily: 'Instrument Sans, sans-serif',
              fontWeight: 400,
              fontSize: '16px',
              color: 'rgba(9,23,23,0.8)',
              marginTop: '16px',
              marginBottom: 0
            }}>
                Long-form text responses, limited engagement.
              </p>
            </div>

            {/* Right: Interactive / MCP Apps */}
            <div data-name="Interactive Column">
              <div data-name="Column Header" className="mcp-col-header" style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'baseline',
              marginBottom: '24px'
            }}>
                <span className="mcp-col-title" style={{
                fontFamily: 'Instrument Sans, sans-serif',
                fontWeight: 500,
                fontSize: '24px',
                color: '#091717'
              }}>
                  Interactive
                </span>
                <span className="mcp-col-badge" style={{
                fontFamily: 'Instrument Sans, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                borderRadius: '999px',
                border: '1px solid rgba(90,174,212,0.3)',
                padding: '5px 12px',
                color: '#5AAED4',
                background: 'transparent',
                whiteSpace: 'nowrap'
              }}>
                  MCP Apps
                </span>
              </div>

              <img src={INTERACTIVE_IMAGE} alt="Interactive MCP App — dynamic UI inside AI conversation" style={{
              width: '100%',
              aspectRatio: '4 / 3',
              objectFit: 'cover',
              display: 'block'
            }} />

              <p style={{
              fontFamily: 'Instrument Sans, sans-serif',
              fontWeight: 400,
              fontSize: '16px',
              color: 'rgba(9,23,23,0.8)',
              marginTop: '16px',
              marginBottom: 0
            }}>
                Dynamic data visualization with direct interaction capabilities.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Section 3: Testimonial Quote ── */}
      <section data-name="MCP Quote" data-nav-theme="dark" style={{
      backgroundColor: '#091717',
      width: '100%'
    }}>
        <div className="mcp-quote-inner" style={{
        maxWidth: '1360px',
        margin: '0 auto',
        paddingLeft: '24px',
        paddingRight: '24px',
        paddingTop: '80px',
        paddingBottom: '80px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
          <blockquote data-name="Quote Text" className="mcp-quote-text" style={{
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400,
          fontSize: '44px',
          lineHeight: 1.3,
          color: '#FCFAF6',
          maxWidth: '900px',
          margin: 0,
          textAlign: 'center',
          fontStyle: 'normal'
        }}>
            "This will enable a new generation of apps that are interactive, adaptive and personalized, that you can chat with."
          </blockquote>
          <p data-name="Quote Attribution" className="mcp-quote-attribution" style={{
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400,
          fontSize: '20px',
          color: '#FCFAF6',
          marginTop: '32px',
          marginBottom: 0,
          textAlign: 'center'
        }}>
            Sam Altman / CEO, OpenAI — DevDay 2025
          </p>
        </div>
      </section>

      {/* ── Section 4: What are MCP apps? ── */}
      <section data-name="What Are MCP Apps" data-nav-theme="light" style={{
      backgroundColor: '#FCFAF6'
    }}>
        <div data-name="What Are Content" className="mcp-what-inner" style={{
        maxWidth: '1360px',
        margin: '0 auto',
        paddingLeft: '24px',
        paddingRight: '24px',
        paddingTop: '120px',
        paddingBottom: '120px',
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: '80px',
        alignItems: 'start'
      }}>
          {/* Left: title + description */}
          <div data-name="What Are Copy">
            <h2 data-name="What Are Title" className="mcp-what-title" style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400,
            fontSize: '92px',
            lineHeight: 1.0,
            color: '#091717',
            margin: 0,
            fontStyle: 'normal'
          }}>
              What are<br />MCP apps?
            </h2>
            <p data-name="What Are Description" className="mcp-what-desc" style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400,
            fontSize: 'clamp(16px, 1.5vw, 20px)',
            color: 'rgba(9,23,23,0.7)',
            lineHeight: 1.4,
            marginTop: '32px',
            marginBottom: 0
          }}>
              AI conversations just gained a user interface layer. MCP Apps embed interactive UIs — dashboards, forms, storefronts — directly in the chat, so users act on information the moment the model surfaces it.
            </p>
          </div>

          {/* Right: three stacked items */}
          <div data-name="What Are Items">
            {[{
            label: 'What they are',
            body: 'Interactive UIs — dashboards, forms, visualizations — rendered directly inside the chat. Two-way data flow: apps call tools, models push results back to the UI in real time.'
          }, {
            label: 'What they are NOT',
            body: 'A browser tab crammed into a chat window. Standalone apps with a chat wrapper bolted on. Static previews or read-only embeds.'
          }, {
            label: 'The distinction',
            body: 'They preserve conversational context across steps — no tab switching required.'
          }].map((item, i) => <div key={i} data-name={`Item ${i + 1}`} className="mcp-what-item" style={{
            borderTop: '1px solid rgba(9, 23, 23, 0.12)',
            paddingTop: '32px',
            paddingBottom: '32px'
          }}>
                <p className="mcp-card-title" style={{
              fontFamily: 'Instrument Sans, sans-serif',
              fontWeight: 500,
              fontSize: '20px',
              color: '#091717',
              margin: 0,
              marginBottom: '16px'
            }}>
                  {item.label}
                </p>
                <p style={{
              fontFamily: 'Instrument Sans, sans-serif',
              fontWeight: 400,
              fontSize: '16px',
              color: 'rgba(9, 23, 23, 0.8)',
              lineHeight: 1.6,
              margin: 0
            }}>
                  {item.body}
                </p>
              </div>)}
            {/* Bottom border for last item */}
            <div style={{
            borderTop: '1px solid rgba(9, 23, 23, 0.12)'
          }} />
          </div>
        </div>
      </section>

      {/* ── Section 5: The Strategic Advantage ── */}
      <section data-name="Strategic Advantage" data-nav-theme="light" style={{
      backgroundColor: '#FCFAF6'
    }}>
        <div data-name="Strategic Content" className="mcp-strategic-inner" style={{
        maxWidth: '1360px',
        margin: '0 auto',
        paddingLeft: '24px',
        paddingRight: '24px',
        paddingTop: '120px',
        paddingBottom: '120px'
      }}>
          <h2 data-name="Strategic Title" className="mcp-section-title" style={{
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400,
          fontSize: '56px',
          lineHeight: 1.1,
          color: '#091717',
          margin: 0,
          marginBottom: '44px'
        }}>
            The strategic advantage
          </h2>

          <div data-name="Advantage Grid" className="mcp-advantage-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
          gap: '40px'
        }}>
            {[{
            icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/icon-1-9gdinkfy65p.png',
            title: 'Workflow continuity',
            description: 'Users stay in the conversation. No tab switching, no lost state. The AI and the interface share one unbroken thread — intent flows straight into action.'
          }, {
            icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/icon-2-uo63d4adlo.png',
            title: 'Bidirectional data flow',
            description: 'A two-way street. Click a button in the UI and the AI sees it; the AI updates data and the UI changes instantly. Real interaction, not read-only embeds.'
          }, {
            icon: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/icon-3-xik9xxekuvk.png',
            title: 'Sandboxed security',
            description: 'Every app runs in an isolated iframe. No cookie access, no DOM leaks, no cross-origin reach. Hosts enforce Content Security Policy — apps get exactly the permissions they declare, nothing more.'
          }].map((col, i) => <div key={i} data-name={`Advantage Column ${i + 1}`}>
                <div className="mcp-card-icon-row" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              marginBottom: '16px'
            }}>
                  <img src={col.icon} alt="" aria-hidden="true" className="mcp-advantage-icon" style={{
                width: '44px',
                height: '44px',
                borderRadius: '50%',
                display: 'block',
                flexShrink: 0
              }} />
                  <p className="mcp-card-title" style={{
                fontFamily: 'Instrument Sans, sans-serif',
                fontWeight: 500,
                fontSize: '20px',
                color: '#091717',
                margin: 0
              }}>
                    {col.title}
                  </p>
                </div>
                <p style={{
              fontFamily: 'Instrument Sans, sans-serif',
              fontWeight: 400,
              fontSize: '16px',
              color: 'rgba(9, 23, 23, 0.8)',
              lineHeight: 1.6,
              margin: 0
            }}>
                  {col.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* ── Section 6: Who MCP Apps Are For ── */}
      <section data-name="Who MCP Apps Are For" data-nav-theme="dark" style={{
      backgroundColor: '#091717',
      width: '100%'
    }}>
        <div data-name="Who MCP Content" className="mcp-for-inner" style={{
        maxWidth: '1360px',
        margin: '0 auto',
        paddingLeft: '24px',
        paddingRight: '24px',
        paddingTop: '120px',
        paddingBottom: '120px',
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: '80px',
        alignItems: 'start'
      }}>
          {/* Left */}
          <div data-name="Who MCP Copy">
            <h2 data-name="Who MCP Title" className="mcp-who-title" style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400,
            fontSize: '92px',
            lineHeight: 1.0,
            color: '#FCFBF7',
            margin: 0,
            fontStyle: 'normal'
          }}>
              Who MCP<br />apps are for
            </h2>
            <p data-name="Who MCP Description" style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400,
            fontSize: 'clamp(16px, 1.5vw, 20px)',
            color: 'rgba(252, 251, 247, 0.7)',
            lineHeight: 1.4,
            marginTop: '32px',
            marginBottom: 0
          }}>
              For teams building interactive, on-brand experiences inside the chat — where context, multi-step flows, and live updates matter more than sending users to another tab.
            </p>
          </div>

          {/* Right: 2×2 card grid */}
          <div data-name="Who MCP Cards" className="mcp-for-cards" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gap: '40px'
        }}>
            {([{
            icon: WHO_ICON_1,
            title: 'Product teams',
            description: 'Turn conversational intent into guided, multi-step workflows — right inside the chat. Build interactive UIs (forms, filters, drill-downs) that keep state and update as results come in.'
          }, {
            icon: WHO_ICON_2,
            title: 'Marketing and growth teams',
            description: 'Reduce drop-off by keeping users in the moment. Use embedded experiences that turn interest into action without sending people to another tab.'
          }, {
            icon: WHO_ICON_3,
            title: 'Internal ops',
            description: 'Build internal dashboards, approval workflows, and data lookups that live inside the chat. No context switching, no extra apps — your team acts on info the moment the AI surfaces it.'
          }, {
            icon: WHO_ICON_4,
            title: 'Designers and UX',
            description: "Design UI that adapts to conversational context — where the model's understanding shapes what users see. Build once, render across Claude, ChatGPT, VS Code, and Goose."
          }] as {
            icon: string;
            title: string;
            description: string;
          }[]).map((card, i) => <div key={i} data-name={`Who Card ${i + 1}`}>
                <div className="mcp-card-icon-row" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              marginBottom: '16px'
            }}>
                  <img src={card.icon} alt="" aria-hidden="true" style={{
                width: '44px',
                height: '44px',
                borderRadius: '50%',
                display: 'block',
                flexShrink: 0
              }} />
                  <p className="mcp-card-title" style={{
                fontFamily: 'Instrument Sans, sans-serif',
                fontWeight: 500,
                fontSize: '20px',
                color: '#FCFBF7',
                margin: 0
              }}>
                    {card.title}
                  </p>
                </div>
                <p style={{
              fontFamily: 'Instrument Sans, sans-serif',
              fontWeight: 400,
              fontSize: '16px',
              color: 'rgba(252, 251, 247, 0.8)',
              lineHeight: 1.6,
              margin: 0
            }}>
                  {card.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* ── Section 7: Understanding Concepts ── */}
      <section data-name="Understanding Concepts" data-nav-theme="dark" style={{
      backgroundColor: '#091717',
      width: '100%'
    }}>
        <div data-name="Concepts Content" className="mcp-concepts-inner" style={{
        maxWidth: '1360px',
        margin: '0 auto',
        paddingLeft: '24px',
        paddingRight: '24px',
        paddingTop: '120px',
        paddingBottom: '120px'
      }}>
          <h2 data-name="Concepts Title" className="mcp-concepts-title" style={{
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400,
          fontSize: '56px',
          lineHeight: 1.0,
          color: '#FCFAF6',
          margin: 0,
          marginBottom: '44px'
        }}>
            Understanding concepts
          </h2>

          <div data-name="Concepts Slider" style={{
          overflow: 'hidden'
        }}>
            <Swiper modules={[FreeMode]} slidesPerView="auto" freeMode={true} spaceBetween={16} onSwiper={(swiper: any) => {
            conceptsSwiperRef.current = swiper;
          }}>
              {([{
              letter: 'A',
              title: 'AI Coding Agent',
              body: 'A specialized AI tool that can help developers build these apps automatically by following a set of "skills" or instructions.'
            }, {
              letter: 'B',
              title: 'Bidirectional Data Flow',
              body: 'The ability for the app and the AI to talk back and forth in real-time. For example, clicking a button in the app can instantly send new information back to the AI.'
            }, {
              letter: 'C',
              title: 'Context Preservation',
              body: 'The benefit of keeping the app and the conversation in the same place. This prevents you from having to switch between different browser tabs or lose your place in a discussion.'
            }, {
              letter: 'H',
              title: 'Host',
              body: 'The main program where you are chatting with the AI. Examples of hosts include Claude Desktop, VS Code, or Goose.'
            }, {
              letter: 'J',
              title: 'JSON-RPC',
              body: 'The technical "language" or protocol that the app and the host use to send messages to one another.'
            }, {
              letter: 'M',
              title: 'Model Context Protocol (MCP)',
              body: 'MCP is a standardized protocol that tells AI models how to discover, call, and use external tools safely and consistently.'
            }, {
              letter: 'M',
              title: 'MCP Apps',
              body: 'An MCP App is a UI experience embedded in a chat, powered by MCP, that lets users see and do things — not just read text.'
            }, {
              letter: 'R',
              title: 'Resource',
              body: "Any piece of content (like a file, an image, or the app's code) that the host fetches from the server to display to the user."
            }, {
              letter: 'S',
              title: 'Sandboxed iframe',
              body: "A security feature that acts like a protective container for the app. It allows the app to run safely inside your chat window while preventing it from accessing your private computer files or cookies."
            }, {
              letter: 'S',
              title: 'SDK (Software Development Kit)',
              body: 'A collection of pre-made tools and code libraries that help developers build MCP Servers and Apps more easily.'
            }, {
              letter: 'S',
              title: 'Server',
              body: "The backend system that provides the app's information and logic. It sends the app's interface to the host when requested."
            }, {
              letter: 'T',
              title: 'Tool',
              body: 'A specific command the AI can use to perform an action, such as "Get Server Time" or "Search Catalog". In an MCP App, a tool often triggers the visual window to open.'
            }] as {
              letter: string;
              title: string;
              body: string;
            }[]).map((concept, i) => <SwiperSlide key={i} style={{
              width: '288px'
            }}>
                  <div data-name={`Concept Card ${concept.letter} ${concept.title}`} style={{
                height: '300px',
                background: 'rgba(252, 251, 247, 0.1)',
                padding: '24px',
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}>
                    {/* Letter badge */}
                    <div aria-hidden="true" style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '50%',
                  background: 'rgba(252, 251, 247, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontFamily: 'Instrument Sans, sans-serif',
                  fontWeight: 500,
                  fontSize: '18px',
                  color: '#FCFBF7',
                  flexShrink: 0
                }}>
                      {concept.letter}
                    </div>
                    {/* Title + description */}
                    <div>
                      <p style={{
                    fontFamily: 'Instrument Sans, sans-serif',
                    fontWeight: 500,
                    fontSize: '16px',
                    color: '#FCFBF7',
                    margin: 0,
                    marginBottom: '8px'
                  }}>
                        {concept.title}
                      </p>
                      <p className="mcp-concept-body" style={{
                    fontFamily: 'Instrument Sans, sans-serif',
                    fontWeight: 400,
                    fontSize: '13px',
                    color: 'rgba(252, 251, 247, 0.8)',
                    lineHeight: 1.5,
                    margin: 0,
                    overflow: 'hidden',
                    display: '-webkit-box',
                    WebkitLineClamp: 5,
                    WebkitBoxOrient: 'vertical'
                  } as React.CSSProperties}>
                        {concept.body}
                      </p>
                    </div>
                  </div>
                </SwiperSlide>)}
            </Swiper>
          </div>

          {/* Navigation arrows */}
          <div data-name="Concepts Navigation" style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '8px',
          marginTop: '24px'
        }}>
            <button aria-label="Previous concept" onClick={() => conceptsSwiperRef.current?.slidePrev()} style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400,
            fontSize: '24px',
            color: 'rgba(252, 250, 246, 0.6)',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '8px 12px',
            lineHeight: 1,
            transition: 'color 0.2s ease'
          }} onMouseEnter={e => e.currentTarget.style.color = '#FCFAF6'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(252, 250, 246, 0.6)'} data-tracking-id="btn-d0fde5aa070320e2">←</button>
            <button aria-label="Next concept" onClick={() => conceptsSwiperRef.current?.slideNext()} style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400,
            fontSize: '24px',
            color: 'rgba(252, 250, 246, 0.6)',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '8px 12px',
            lineHeight: 1,
            transition: 'color 0.2s ease'
          }} onMouseEnter={e => e.currentTarget.style.color = '#FCFAF6'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(252, 250, 246, 0.6)'} data-tracking-id="btn-0a6a6c1aa9d3f63f">→</button>
          </div>
        </div>
      </section>

      {/* ── Section 8: Who is behind MCP Apps ── */}
      <section data-name="Who Is Behind MCP Apps" data-nav-theme="dark" style={{
      backgroundColor: '#091717',
      width: '100%'
    }}>
        <div data-name="Behind Content" className="mcp-behind-inner" style={{
        maxWidth: '1360px',
        margin: '0 auto',
        paddingLeft: '24px',
        paddingRight: '24px',
        paddingTop: '120px',
        paddingBottom: '120px',
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: '80px',
        alignItems: 'start'
      }}>
          {/* Left */}
          <div data-name="Behind Copy">
            <h2 className="mcp-who-title" style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400,
            fontSize: '92px',
            lineHeight: 1.0,
            color: '#FCFBF7',
            margin: 0
          }}>
              Who is behind<br />MCP apps
            </h2>
            <p style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400,
            fontSize: 'clamp(16px, 1.5vw, 20px)',
            color: 'rgba(252, 251, 247, 0.7)',
            lineHeight: 1.4,
            marginTop: '32px',
            marginBottom: 0
          }}>
              MCP Apps are being shaped by the maintainers behind MCP-UI, plus teams at OpenAI and Anthropic. The proposal builds on real patterns tested in the UI working group and formalizes them into a shared standard.
            </p>
          </div>

          {/* Right: org blocks */}
          <div data-name="Org Blocks">
            {([{
            name: 'MCP-UI',
            description: 'Incubated and championed core UI patterns via the #ui-wg community.',
            contributors: [{
              name: 'Ido Salomon',
              github: 'https://github.com/idosal',
              twitter: 'https://x.com/idosal1'
            }, {
              name: 'Liad Yosef',
              github: 'https://github.com/liady',
              twitter: 'https://x.com/liadyosef'
            }, {
              name: 'Jonathan Hefner',
              github: 'https://github.com/jonathanhefner',
              twitter: null as string | null
            }]
          }, {
            name: 'Anthropic',
            description: 'Helped steer the initiative and drive collaboration.',
            contributors: [{
              name: 'Sean Strong',
              github: null as string | null,
              twitter: 'https://x.com/sean_t_strong'
            }, {
              name: 'Olivier Chafik',
              github: 'https://github.com/ochafik',
              twitter: 'https://x.com/ochafik'
            }, {
              name: 'Anton Pidkuiko',
              github: 'https://github.com/antonpk1',
              twitter: 'https://x.com/antonpidkuiko'
            }, {
              name: 'Jerome Swannack',
              github: 'https://github.com/jerome3o',
              twitter: 'https://x.com/JeromeSwannack'
            }]
          }, {
            name: 'OpenAI',
            description: 'Provided direction informed by building the Apps SDK.',
            contributors: [{
              name: 'Nick Cooper',
              github: 'https://github.com/nicknotfun',
              twitter: 'https://x.com/nicknotfun'
            }, {
              name: 'Alexei Christakis',
              github: 'https://github.com/alexi-openai',
              twitter: 'https://x.com/AlexiChristakis'
            }, {
              name: 'Bryan Ashley',
              github: 'https://github.com/bryanashley',
              twitter: 'https://x.com/bash_ba'
            }]
          }] as Array<{
            name: string;
            description: string;
            contributors: Array<{
              name: string;
              github: string | null;
              twitter: string | null;
            }>;
          }>).map((org, i) => <React.Fragment key={org.name}>
                {i > 0 && <div style={{
              height: '1px',
              background: 'rgba(255, 255, 255, 0.12)'
            }} />}
                <div data-name={`${org.name} Block`} className="mcp-org-block" style={{
              paddingTop: i === 0 ? 0 : '40px',
              paddingBottom: '40px'
            }}>
                  <p className="mcp-card-title" style={{
                fontFamily: 'Instrument Sans, sans-serif',
                fontWeight: 500,
                fontSize: '20px',
                color: '#FCFBF7',
                margin: '0 0 8px 0'
              }}>{org.name}</p>
                  <p style={{
                fontFamily: 'Instrument Sans, sans-serif',
                fontWeight: 400,
                fontSize: '16px',
                color: 'rgba(252, 251, 247, 0.8)',
                lineHeight: 1.6,
                margin: '0 0 16px 0'
              }}>{org.description}</p>
                  <div style={{
                height: '1px',
                background: 'rgba(255, 255, 255, 0.12)',
                marginBottom: '16px'
              }} />
                  <div className="mcp-contributors-list" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
                gap: '16px 24px'
              }}>
                    {org.contributors.map(c => <div key={c.name} data-name={`Contributor ${c.name}`}>
                        <p style={{
                    fontFamily: 'Instrument Sans, sans-serif',
                    fontWeight: 400,
                    fontSize: '16px',
                    color: '#FCFBF7',
                    margin: '0 0 6px 0'
                  }}>{c.name}</p>
                        <div style={{
                    display: 'flex',
                    gap: '8px',
                    alignItems: 'center'
                  }}>
                          {c.github && <a href={c.github} target="_blank" rel="noreferrer" aria-label={`${c.name} on GitHub`} style={{
                      color: 'rgba(255,255,255,0.5)',
                      display: 'inline-flex',
                      transition: 'color 0.2s ease'
                    }} onMouseEnter={e => e.currentTarget.style.color = '#fcfaf6'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.5)'} data-tracking-id="link-340251a17b64ce73">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0 1 12 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z" /></svg>
                            </a>}
                          {c.twitter && <a href={c.twitter} target="_blank" rel="noreferrer" aria-label={`${c.name} on X`} style={{
                      color: 'rgba(255,255,255,0.5)',
                      display: 'inline-flex',
                      transition: 'color 0.2s ease'
                    }} onMouseEnter={e => e.currentTarget.style.color = '#fcfaf6'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.5)'} data-tracking-id="link-9e2cf5cc5c678a9a">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.747l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>
                            </a>}
                        </div>
                      </div>)}
                  </div>
                </div>
              </React.Fragment>)}
            <p style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400,
            fontSize: '16px',
            color: 'rgba(252, 251, 247, 0.8)',
            margin: '40px 0 0 0',
            lineHeight: 1.6
          }}>
              Plus the UI Community Working Group members who shaped the proposal through discussion and feedback.
            </p>
          </div>
        </div>
      </section>

      {/* ── Section 9: MCP Ecosystem ── */}
      <section data-name="MCP Ecosystem" data-nav-theme="light" style={{
      backgroundColor: '#fcfaf6',
      width: '100%'
    }}>
        <div data-name="Ecosystem Content" className="mcp-eco-inner" style={{
        maxWidth: '1360px',
        margin: '0 auto',
        paddingLeft: '24px',
        paddingRight: '24px',
        paddingTop: '120px',
        paddingBottom: '120px'
      }}>
          {/* Title area */}
          <div data-name="Ecosystem Title Area" className="mcp-eco-title-inner" style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr',
          gap: '80px',
          alignItems: 'start',
          marginBottom: '48px'
        }}>
            <h2 className="mcp-what-title mcp-eco-title" style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400,
            fontSize: '92px',
            lineHeight: 1.0,
            color: '#091717',
            margin: 0,
            maxWidth: '800px'
          }}>
              The MCP<br />ecosystem and<br />documentation
            </h2>
            <p style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400,
            fontSize: 'clamp(16px, 1.5vw, 20px)',
            color: 'rgba(9, 23, 23, 0.7)',
            lineHeight: 1.4,
            margin: 0
          }}>
              The Model Context Protocol is defined through official specifications and shaped by the organizations building and adopting it. The resources below represent the main places where MCP and MCP Apps are documented, discussed, and evolving.
            </p>
          </div>

          {/* Cards: 3 × 2 grid */}
          <div data-name="Ecosystem Cards" className="mcp-eco-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
          gap: '16px'
        }}>
            {([{
            title: 'Model Context Protocol',
            description: 'The official MCP specification and documentation — the source of truth for the protocol.',
            link: 'https://modelcontextprotocol.io/'
          }, {
            title: 'MCP Apps Documentation',
            description: 'Official guide to building interactive UI applications that render inside MCP hosts.',
            link: 'https://modelcontextprotocol.io/docs/extensions/apps'
          }, {
            title: 'MCP Apps GitHub',
            description: 'The specification, TypeScript SDK, and 15+ example apps — everything you need to start building.',
            link: 'https://github.com/modelcontextprotocol/ext-apps'
          }, {
            title: 'Introducing MCP Apps',
            description: 'The official announcement of MCP Apps as a standardized extension, co-authored by Anthropic, OpenAI, and MCP-UI.',
            link: 'https://blog.modelcontextprotocol.io/posts/2025-11-21-mcp-apps/'
          }, {
            title: 'Introducing the Model Context Protocol',
            description: "Anthropic's original announcement of MCP — the open standard connecting AI assistants to external systems.",
            link: 'https://www.anthropic.com/news/model-context-protocol'
          }, {
            title: 'OpenAI Apps SDK',
            description: "OpenAI's framework for building interactive apps inside ChatGPT, built on MCP.",
            link: 'https://developers.openai.com/apps-sdk/'
          }] as Array<{
            title: string;
            description: string;
            link: string;
          }>).map((card, i) => <div key={i} data-name={`Ecosystem Card ${i + 1}`} className="mcp-eco-card" style={{
            background: 'rgba(9, 23, 23, 0.05)',
            borderRadius: 0,
            padding: '24px',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
          }}>
                <p className="mcp-card-title" style={{
              fontFamily: 'Instrument Sans, sans-serif',
              fontWeight: 500,
              fontSize: '20px',
              color: '#091717',
              margin: 0
            }}>{card.title}</p>
                <p style={{
              fontFamily: 'Instrument Sans, sans-serif',
              fontWeight: 400,
              fontSize: '16px',
              color: 'rgba(9, 23, 23, 0.8)',
              lineHeight: 1.6,
              margin: 0,
              flex: 1
            }}>{card.description}</p>
                <a href={card.link} target="_blank" rel="noreferrer" className="mcp-eco-read-more" style={{
              fontFamily: 'Instrument Sans, sans-serif',
              fontWeight: 500,
              fontSize: '18px',
              color: '#091717',
              textDecoration: 'none',
              marginTop: 'auto',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '4px'
            }} onMouseEnter={e => e.currentTarget.style.textDecoration = 'underline'} onMouseLeave={e => e.currentTarget.style.textDecoration = 'none'} data-tracking-id="link-c63c3188dd9aa845">
                  Read more <img src="https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/image-arrow-dhxc1f5xkqb.png" alt="" aria-hidden="true" style={{
                width: '1em',
                height: '1em',
                objectFit: 'contain',
                verticalAlign: 'middle'
              }} />
                </a>
              </div>)}
          </div>
        </div>
      </section>

      <Footer />
    </main>;
};